import { injectable } from "inversify";
import UserRepository from "../../repositories/UserRepository";
import { Either } from "fp-ts/lib/Either";
import ExceptionEntity from "../../entities/ExceptionEntity";
import UserProfileEntity from "../../entities/UserProfileEntity";

interface props {
    userRepository: UserRepository;
}

@injectable()
export default class GetUserProfileUseCase {
    _userRepository: UserRepository;

    constructor(_: props) {
        this._userRepository = _.userRepository;
    }

    public call = async (userId: string): Promise<Either<ExceptionEntity, UserProfileEntity>> => {
        return await this._userRepository.getUserProfile(userId);
    };
}

export const GetUserProfileUseCaseName = "GetUserProfileUseCaseName";
